import { IconSize } from 'src/interfaces/Icon';
import useTranslation from 'next-translate/useTranslation';
import IconButton from '../IconButton';
import { SettingsIcon } from '../../icons';
import TooltipWrapper from '../TooltipWrapper';

export type SettingsButtonProps = {
  onClick: () => void;
  iconSize?: IconSize.small | IconSize.medium;
  className?: string;
};

const SettingsButton = ({ onClick, className, iconSize = IconSize.medium }: SettingsButtonProps) => {
  const { t } = useTranslation('common');
  const tooltipText = t('tooltips.settings');

  return (
    <TooltipWrapper tooltipText={tooltipText} tooltipPosition='top'>
      <IconButton
        className={className}
        data-testid='settings-button'
        onClick={onClick}
        icon={<SettingsIcon size={iconSize} />}
        aria-label={tooltipText}
        aria-haspopup
      />
    </TooltipWrapper>
  );
};

export default SettingsButton;
